var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "child-ul-wrapper", class: _vm.float },
    _vm._l(_vm.itemchildren, function (i) {
      return _c("li", { key: i.name, staticClass: "child-li-wrapper" }, [
        i.children && i.children.length > 0
          ? _c(
              "div",
              { staticClass: "has-child" },
              [
                _c("div", { staticClass: "parent-name btn-wrapper-simple" }, [
                  _c("i", {
                    staticClass: "nav-icon-fontawe",
                    class: i.icoName ? i.icoName : "",
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "nav-name-right" }, [
                    _vm._v(_vm._s(i.btnName)),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "icon" }),
                ]),
                _vm._v(" "),
                _c("tree-child-component", {
                  attrs: { itemchildren: i.children, float: _vm.float },
                  on: { childhandler: _vm.fnHandler },
                }),
              ],
              1
            )
          : _c("div", [
              _c(
                "div",
                {
                  staticClass: "no-child-btn btn-wrapper-simple",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.fnHandler(i, $event)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "nav-icon-fontawe",
                    class: i.icoName ? i.icoName : "",
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "nav-name-right" }, [
                    _vm._v(_vm._s(i.btnName)),
                  ]),
                ]
              ),
            ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }